import { render } from "./SalesReturnReportPage.vue?vue&type=template&id=2947f7b8&scoped=true&ts=true"
import script from "./SalesReturnReportPage.vue?vue&type=script&lang=ts"
export * from "./SalesReturnReportPage.vue?vue&type=script&lang=ts"

import "./SalesReturnReportPage.vue?vue&type=style&index=0&id=2947f7b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2947f7b8"]])

export default __exports__